module.exports = __webpack_public_path__ + "static/img/fruits_strowberry.cbe868f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fruits_strowberry.png
// module id = wx5l
// module chunks = 1